/** FloatHelm-style staff Home. No fabricated shifts, vacations or tasks:
 * sections deliberately disclose unavailable sources until their authorized
 * scheduling and operations APIs are connected.
 */
export function StaffHomeWorkspace({displayName,canApproveVacations=false}:{
  displayName:string;canApproveVacations?:boolean;
}){
  const first=displayName.trim().split(/\s+/)[0]||'';
  const sections=[
    {title:'Upcoming Shifts',empty:'Upcoming shift assignments are not yet connected.'},
    {title:'Upcoming Vacations',empty:'Vacation schedule is not yet connected.'},
    {title:'Upcoming Tasks',empty:'Task assignments are not yet connected.'},
  ];
  return <section className="ecfs-home" aria-label="Team Member home">
    <div className="ecfs-home-heading">
      <h1>Home</h1>
      {first&&<p>Welcome, {first}</p>}
    </div>
    <div className="ecfs-home-accordions">
      {canApproveVacations&&<details className="ecfs-home-accordion" open>
        <summary>Vacation Requests</summary>
        <div className="ecfs-home-accordion-body">
          Vacation request approvals are not yet connected to this staging system.
        </div>
      </details>}
      {sections.map((section,index)=>
        <details key={section.title} className="ecfs-home-accordion" open={index===0}>
          <summary>{section.title}</summary>
          <div className="ecfs-home-accordion-body">{section.empty}</div>
        </details>)}
    </div>
  </section>;
}
